import initCarousel from '../helpers/carousel';
import { unitlessBreakpoints } from '../helpers/breakpoints';

export default class DynamicArticleFeed {
  constructor(section) {
    this.carousel = initCarousel(section.el, {
      perPage: 1,
      pagination: false,
      arrows: false,
      gap: '0.5rem',
      padding: {
        right: 70,
      },
      breakpoints: {
        [unitlessBreakpoints.sm]: {
          perPage: 2,
          padding: {
            right: 30,
          },
        },
        [unitlessBreakpoints.md]: {
          perPage: 3,
        },
        [unitlessBreakpoints.lg]: {
          perPage: 4,
          padding: {
            right: 0,
          },
        },
      },
    });
  }
}
